import React from 'react'
import hc1 from "../../Assets/images/step-1.png"
import hc2 from "../../Assets/images/step-2.png"
import hc3 from "../../Assets/images/step-3.png"
const Steps = () => {
  return (
    <>
    <section className='section-top-padding'>
        <div className='container'>
            <h2 className='heading-title mb-3 mb-lg-5'>
                Land Your First Job in
                <span className='gr-txt d-block d-lg-inline-block ms-0 ms-lg-2'>3 Steps</span>
            </h2>
            <div className='row'>
              <div className='col-6 col-lg-4 mb-3 mb-lg-0'>
                  <div className='hiring-card'>
                      <div>
                        <div className='default-btn'>Step 1</div>
                        <h2 className='text-lg-center mt-3 mt-lg-5'>Sign Up & Create <br/> Portfolio</h2>
                        <p className='text-lg-center'>Upload videos, assignments, and complete quizzes.</p>
                      </div>
                      <img src={hc1} alt='' className='mw-100'/>
                  </div>
              </div>
              <div className='col-6 col-lg-4 mb-3 mb-lg-0'>
                  <div className='hiring-card'>
                      <div>
                        <div className='default-btn'>Step 2</div>
                        <h2 className='text-lg-center  mt-3 mt-lg-5'>Get Discovered <br /> by Companies</h2>
                        <p className='text-lg-center'>Recruiters view verified profiles matching their job requirements.</p>
                      </div>
                      <img src={hc2} alt='' className='mw-100'/>
                  </div>
              </div>
              <div className='col-12 col-lg-4'>
                  <div className='hiring-card d-flex d-lg-block'>
                      <div className='col-6 col-md-12'>
                        <div className='default-btn'>Step 3</div>
                        <h2 className='text-lg-center  mt-3 mt-lg-5'>Interview & <br />Get Hired</h2>
                        <p className='text-lg-center'>Apply to shortlisted roles and land interviews with top recruiters.</p>
                      </div>
                      <img src={hc3} alt='' className='col-6 col-md-12'/>
                  </div>
              </div>
            </div>
        </div>
      </section>
    </>
  )
}

export default Steps